import notificationServices from './notification.services';
import authActions from '../Actions/auth.actions';
import { store } from '../Helpers';
import { deleteCookie } from './Storage Services';

let hasAlreadyLoggedOut = false;

export const resetLogoutFlag = () => {
	hasAlreadyLoggedOut = false;
};

const handleResponse = (response) => {
	return response.text().then((text) => {
		const data = text && JSON.parse(text);
		const isError =
			data.status === 'Failed' ||
			data.errorMessage ||
			(data.responseCode && data.responseCode !== 'SS-001');

		if (isError) {
			let error = data.errorMessage || data.message || data.responseMessage;
			if (error === 'Auth_Invalid' ||
				error === 'Unauthorized Access' ||
				data.statusCode === 403
			) {
				if (!hasAlreadyLoggedOut) {
					hasAlreadyLoggedOut = true;
					deleteCookie('user');
					error = 'Your session has expired';
					store.dispatch(authActions.toggleLogout(true));
				}
				return {};
			}

			if (!store.getState().auth.isLoading) {
				store.dispatch(authActions.toggleLoading(false));
				notificationServices.generateNotification({
					type: 'error',
					message: error,
				});
			}

			if (data.statusCode === 413) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Data is too large',
				});
			}

			return Promise.reject(error);
		}

		return data;
	});
};

export default handleResponse;
